import * as React from "react";

interface ProcessStepProps {
  number: number;
  title: string;
}

export const ProcessStep: React.FC<ProcessStepProps> = ({ number, title }) => {
  return (
    <article className="relative self-stretch my-auto w-[140px] z-10 h-48">
      <h3 className="leading-6 text-grey-800 text-body-md font-bold">{title}</h3>
      <div className="overflow-hidden mt-5 size-10 text-white whitespace-nowrap bg-dark-900 min-h-10 rounded-[999px] flex items-center justify-center">
        {number}
      </div>
      <div className="absolute bg-white size-20 bottom-16 -left-5 -z-10"/>
    </article>
  );
};
